import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  CardHeader,
  withStyles,
  InputBase,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import clientBackend from "configurations/axios";
import { useSelector } from "react-redux";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { useStylesApp } from "hooks/useStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(0),
    textAlign: "center",
    color: theme.palette.text.primary,
    margin: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    boxShadow: "5px 3px 3px #aaaaaa",
    borderRadius: "8px",
    borderWidth: "2px",
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "0%",
    textAlign: "justify",
  },
  divInput: {
    marginBottom: "0%",
    paddingRight: "0%",
    paddingLeft: "0%",
    textAlign: "justify",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  haedClient: {
    backgroundColor: palette.primary.main,
    width: "10%",
    display: "flex",
    flexWrap: "wrap",
    borderStyle: "solid",
    borderBottomWidth: "5px",
    borderRadius: "8px",
  },
  formClient: {
    padding: "10px",
  },
}));
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);
const ExportInvoice = ({
  exportDataInvoice,
  setExportDataInvoice,
  setErrorsExportDataInvoice,
  errorsExportDataInvoice,
}) => {
  const tokenUser = useSelector((state) => state.user.tk);
  const classes = useStyles();
  const classesGlobales = useStylesGlobal();
  const [options, setOptions] = useState([]);
  const classesApp = useStylesApp();
  const [foundMoneda, setFoundMoneda] = useState({});
  const [open, setOpen] = useState(false);
  const [existMoneda, setExistMoneda] = useState(false);
  const loading = open && options.length === 0;
  const [optionsIncoterms, setOptionsIncoterms] = useState([]);
  const [foundIncoterms, setFoundIncoterms] = useState({});
  const [openIncoterms, setOpenIncoterms] = useState(false);
  const [existIncoterms, setExistIncoterms] = useState(false);
  const loadingIncoterms = openIncoterms && optionsIncoterms.length === 0;
  const handleChange = (event) => {
    setExportDataInvoice({
      ...exportDataInvoice,
      [event.target.name]: event.target.value,
    });
  };

  useEffect(() => {
    if (foundMoneda !== null) {
      setExportDataInvoice({
        ...exportDataInvoice,
        monedaOperacion: foundMoneda.codigo,
      });
    }
  }, [foundMoneda]);

  useEffect(() => {
    setExportDataInvoice({
      ...exportDataInvoice,
      condicionEntrega:
      foundIncoterms ? 
        Object.keys(foundIncoterms).length !== 0 
          ? foundIncoterms.condicion
          : ""
          : "",
    });
  }, [foundIncoterms]);

  //método para la busqueda para la moneda
  const searchMoneda = async (params) => {
    await clientBackend
      .get(`/admin/moneda/buscar?parametroBusqueda=${params}`)
      .then((response) => {
        if (response.status === 200) {
          if (Array.isArray(response.data)) {
            if (response.data.length > 0) {
              setOptions(
                response.data.map(function (data, index, array) {
                  return {
                    id: data.id,
                    codigo: data.codigo,
                    divisa: data.divisa,
                    numero: data.numero,
                  };
                })
              );
              setExistMoneda(false);
            } else {
              setOptions([
                {
                  id: "",
                  codigo: "",
                  divisa: "No se encontró datos con el argumento ingresado",
                },
              ]);
              setExistMoneda(true);
            }
          }
          setOpen(true);
        }
      })
      .catch((exception) => {
        if (exception.response) {
          setOptions([
            {
              id: "",
              codigo: "",
              divisa: "No se encontró datos con el argumento ingresado",
            },
          ]);
        } else {
          setOptions([
            {
              id: "",
              codigo: "",
              divisa: "Error en la red al consultar el cliente.",
            },
          ]);
        }
      });
  };

  //metodo de busqueda para incoterms
  const searchIncoterms = async (params) => {
    await clientBackend
      .get(`/admin/incoterms/buscar?parametroBusqueda=${params}`)
      .then((response) => {
        if (response.status === 200) {
          if (Array.isArray(response.data)) {
            if (response.data.length > 0) {
              setOptionsIncoterms(
                response.data.map(function (data, index, array) {
                  return {
                    id: data.id,
                    condicion: data.condicion,
                    interpretacion: data.interpretacion,
                    textoOriginal: data.textoOriginal,
                  };
                })
              );
              setExistIncoterms(false);
            } else {
              setOptionsIncoterms([
                {
                  id: "",
                  condicion: "",
                  textoOriginal:
                    "No se encontró datos con el argumento ingresado",
                },
              ]);
              setExistIncoterms(true);
            }
          }
          setOpenIncoterms(true);
        }
      })
      .catch((exception) => {
        if (exception.response) {
          setOptionsIncoterms([
            {
              id: "",
              condicion: "",
              textoOriginal: "No se encontró datos con el argumento ingresado",
            },
          ]);
        } else {
          setOptionsIncoterms([
            {
              id: "",
              condicion: "",
              textoOriginal: "Error en la red al consultar el cliente.",
            },
          ]);
        }
      });
  };

  return (
    <Fragment>
      <div className={classesGlobales.rootDiv}>
        <Grid container xs={12} md={12} justify="center">
          <CardHeader
            className={classesGlobales.cabecera}
            title={"Datos de exportación"}
            avatar={<AssignmentIcon></AssignmentIcon>}
          />
        </Grid>
        <Grid container spacing={1} className={classesGlobales.containerForm}>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Condición de entrega: <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Autocomplete
              id="incoterms"
              onChange={(e, value) => {
                setFoundIncoterms(value);
              }}
              open={openIncoterms}
              onOpen={() => {
                setOpenIncoterms(true);
              }}
              onClose={() => {
                setOpenIncoterms(false);
              }}
              getOptionDisabled={(option) =>
                option.condicion.includes(
                  "No se encontró datos con el argumento ingresado"
                ) ||
                option.condicion.includes(
                  "Error en la red al consultar la condición de entrega."
                )
              }
              getOptionSelected={(option, value) =>
                option.condicion === value.condicion
              }
              getOptionLabel={(option) =>
                `${option.condicion} - ${option.textoOriginal}`
              }
              options={optionsIncoterms}
              noOptionsText={"No se encontró datos con el argumento ingresado"}
              loadingText="Ingrese al menos 3 caracteres"
              loading={optionsIncoterms.length === 0}
              renderInput={(params) => (
                <TextField
                  className={
                    foundIncoterms
                      ? foundIncoterms.condicion
                        ? "form-control  is-valid"
                        : null
                      : null
                  }
                  onChange={(event) => {
                    if (event.target.value.length >= 2) {
                      searchIncoterms(event.target.value);
                    }
                  }}
                  {...params}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingIncoterms ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
            <small style={{ color: "#818181" }}>
              También puede buscarlo por el texto Original.
            </small>
            {errorsExportDataInvoice.condicionEntrega ? (
              <p className={classesApp.errorLetters}>
                {errorsExportDataInvoice.condicionEntrega}
              </p>
            ) : null}
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>Moneda de la operación:</label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Autocomplete
              id="moneda"
              onChange={(e, value) => {
                setFoundMoneda(value);
              }}
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              getOptionDisabled={(option) =>
                option.codigo.includes(
                  "No se encontró datos con el argumento ingresado"
                ) ||
                option.codigo.includes(
                  "Error en la red al consultar la moneda."
                )
              }
              getOptionSelected={(option, value) =>
                option.codigo === value.codigo
              }
              getOptionLabel={(option) => `${option.codigo} - ${option.divisa}`}
              options={options}
              noOptionsText={"No se encontró datos con el argumento ingresado"}
              //inputValue={foundClient}
              loadingText="Ingrese al menos 3 caracteres"
              loading={options.length === 0}
              renderInput={(params) => (
                <TextField
                  className={
                    foundMoneda
                      ? foundMoneda.codigo
                        ? "form-control  is-valid"
                        : null
                      : null
                  }
                  onChange={(event) => {
                    if (event.target.value.length >= 2) {
                      searchMoneda(event.target.value);
                    }
                  }}
                  {...params}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
            <small style={{ color: "#818181" }}>
              También puede buscarlo por la Divisa.
            </small>
          </Grid>
          {exportDataInvoice.monedaOperacion === "ZZZ" ? (
            <Fragment>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  Otra moneda: <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                <input
                  className={"form-control "}
                  type="text"
                  placeholder="Dólar"
                  name="detalleMoneda"
                  value={exportDataInvoice.detalleMoneda}
                  onChange={handleChange}
                />
                {errorsExportDataInvoice.detalleMoneda ? (
                  <p className={classesApp.errorLetters}>
                    {errorsExportDataInvoice.detalleMoneda}
                  </p>
                ) : null}
              </Grid>
            </Fragment>
          ) : null}

          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>Tipo de cambio:</label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <input
              className={"form-control"}
              type="text"
              placeholder="Ej. 1.10"
              name="tipoCambio"
              value={exportDataInvoice.tipoCambio}
              onChange={handleChange}
              autoComplete="off"
            />
            {errorsExportDataInvoice.tipoCambio ? (
              <p className={classesApp.errorLetters}>
                {errorsExportDataInvoice.tipoCambio}
              </p>
            ) : null}
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>Monto de la moneda:</label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <input
              className={"form-control"}
              type="text"
              placeholder="Ej. 1.10"
              name="montoMoneda"
              value={exportDataInvoice.montoMoneda}
              onChange={handleChange}
              autoComplete="off"
            />
            {errorsExportDataInvoice.montoMoneda ? (
              <p className={classesApp.errorLetters}>
                {errorsExportDataInvoice.montoMoneda}
              </p>
            ) : null}
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>Puerto de embarque:</label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <input
              className={"form-control"}
              type="text"
              placeholder="Ej. Puerto de Balboa"
              name="puertoEmbarque"
              value={exportDataInvoice.puertoEmbarque}
              onChange={handleChange}
              autoComplete="off"
            />
            {errorsExportDataInvoice.puertoEmbarque ? (
              <p className={classesApp.errorLetters}>
                {errorsExportDataInvoice.puertoEmbarque}
              </p>
            ) : null}
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default ExportInvoice;
